function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

export { expandToHashMap as e };
//# sourceMappingURL=expandToHashMap-0597ca5d.js.map
